import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Docker1s - 快速稳定的Docker镜像加速服务',
      description: 'Docker1s提供快速、稳定、免费的Docker镜像下载加速服务，支持Docker Hub、gcr.io、k8s.gcr.io等多个镜像仓库',
      keywords: 'docker镜像加速,docker加速器,docker hub加速,容器镜像加速,kubernetes镜像加速,docker1s'
    }
  },
  {
    path: '/docs',
    name: 'Docs',
    component: () => import('../views/Docs.vue'),
    meta: {
      title: 'Docker1s 使用文档 - Docker镜像加速服务配置指南',
      description: '详细的Docker1s使用文档，包括docker镜像加速器配置、kubernetes集群配置、常见问题解答等',
      keywords: 'docker配置,镜像加速器配置,kubernetes配置,docker文档,容器技术文档'
    }
  },
  {
    path: '/status',
    name: 'Status',
    component: () => import('../views/Status.vue'),
    meta: {
      title: 'Docker1s 服务状态 - 实时监控镜像加速服务',
      description: '实时查看Docker1s镜像加速服务的运行状态、性能指标和服务可用性',
      keywords: 'docker服务状态,镜像加速监控,服务可用性,系统状态'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      title: '关于Docker1s - 专业的Docker镜像加速服务提供商',
      description: '了解Docker1s团队和我们提供的专业Docker镜像加速服务，致力于提升开发者的容器使用体验',
      keywords: 'docker1s团队,关于我们,容器技术,docker加速服务'
    }
  },
  // 中文SEO优化页面
  {
    path: '/docker-image-acceleration',
    name: 'DockerImageAcceleration',
    component: Home, // 可以复用Home组件或创建专门的组件
    meta: {
      title: 'Docker镜像加速器 - 免费高速的Docker Hub加速服务 | Docker1s',
      description: '专业的Docker镜像加速器，支持Docker Hub、gcr.io、k8s.gcr.io等镜像仓库的高速下载，全球CDN网络，10倍速度提升，完全免费使用',
      keywords: 'docker镜像加速器,docker hub加速器,容器镜像加速,docker加速下载,镜像拉取加速,docker pull加速,容器技术,kubernetes镜像'
    }
  },
  {
    path: '/docker-acceleration-tutorial',
    name: 'DockerAccelerationTutorial',
    component: () => import('../views/Docs.vue'),
    meta: {
      title: 'Docker镜像加速教程 - 详细配置指南和最佳实践 | Docker1s',
      description: '完整的Docker镜像加速配置教程，包括Linux、macOS、Windows系统配置，Docker Compose和Kubernetes集群配置指南',
      keywords: 'docker加速教程,docker配置指南,镜像加速配置,docker daemon配置,kubernetes镜像配置'
    }
  },
  {
    path: '/dockerhub-proxy',
    name: 'DockerHubProxy',
    component: Home,
    meta: {
      title: 'Docker Hub代理加速 - 稳定快速的Docker Hub镜像代理服务',
      description: 'Docker1s提供稳定的Docker Hub代理服务，解决Docker Hub访问慢的问题，支持所有公开镜像的快速下载',
      keywords: 'docker hub代理,docker hub镜像,docker代理服务,docker镜像下载,容器镜像代理'
    }
  },
  {
    path: '/china-docker-acceleration',
    name: 'ChinaDockerAcceleration',
    component: Home,
    meta: {
      title: '中国Docker加速 - 专为中国开发者优化的Docker镜像加速服务',
      description: '针对中国网络环境优化的Docker镜像加速服务，解决Docker Hub访问慢、下载超时等问题，提供稳定高速的容器镜像下载体验',
      keywords: '中国docker加速,国内docker加速,docker镜像下载,容器技术,docker网络优化,镜像拉取优化'
    }
  },
  {
    path: '/docker-pull-accelerator',
    name: 'DockerPullAccelerator',
    component: Home,
    meta: {
      title: 'Docker Pull加速器 - 极速的Docker镜像拉取服务 | Docker1s',
      description: '专业的Docker Pull加速器，优化docker pull命令的下载速度，支持并行下载和智能缓存，让镜像拉取更快更稳定',
      keywords: 'docker pull加速,镜像拉取加速,docker下载优化,容器镜像拉取,docker pull命令优化'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫，动态设置页面title和meta
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  // 更新meta描述
  if (to.meta.description) {
    let descMeta = document.querySelector('meta[name="description"]')
    if (descMeta) {
      descMeta.setAttribute('content', to.meta.description)
    }
  }
  
  // 更新meta关键词
  if (to.meta.keywords) {
    let keywordsMeta = document.querySelector('meta[name="keywords"]')
    if (keywordsMeta) {
      keywordsMeta.setAttribute('content', to.meta.keywords)
    }
  }
  
  // 更新canonical URL
  let canonicalLink = document.querySelector('link[rel="canonical"]')
  if (canonicalLink) {
    canonicalLink.setAttribute('href', `https://docker1s.com${to.path}`)
  }
  
  next()
})

export default router
